import React from "react";
import { taskOperationsList } from "./constants/task.constants";
import { useTaskContext } from "./context";
import { TaskList } from "./subPages/TaskList";
import { AddTask } from "./subPages/NewTask";
import { UpdateTask } from "./subPages/UpdateTask";

export const TaskPage = () => {
  const { currentOperationPage } = useTaskContext();

  return (
    <>
      {currentOperationPage === taskOperationsList.listTask && <TaskList />}
      {currentOperationPage === taskOperationsList.newTask && <AddTask />}
      {currentOperationPage === taskOperationsList.previewTask && (
        <>Preview Task</>
      )}
      {(currentOperationPage === taskOperationsList.updateTask ||
        currentOperationPage === taskOperationsList.updateTaskTo) && (
        <UpdateTask />
      )}
    </>
  );
};
